export const isValidOption = (option: any) =>
  option !== undefined && option !== null;
